// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"590f2671","453":"1ab3b129","861":"85e7752b","924":"d0eb96f9"}[chunkId] + ".chunk.js";
};